export const authService = {
  storeUserInCache: (user: any) => {
    localStorage.removeItem("user");
    localStorage.setItem("user", JSON.stringify(user));
  },

  getUserFromCache: () => {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  },

  clearUserCache: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  },
};
